var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-row',{staticClass:"text-center safety-measures"},[_c('vs-col',{staticClass:"w-full safety-measures-item safety-measures-heavy-header"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }